import React from 'react'

export const IconDesigns = () => {
    return (
        <svg width="1.5em" height="1.5em" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.25 4.25H3.75C3.35218 4.25 2.97064 4.40804 2.68934 4.68934C2.40804 4.97064 2.25 5.35218 2.25 5.75V19.25C2.25 19.6478 2.40804 20.0294 2.68934 20.3107C2.97064 20.592 3.35218 20.75 3.75 20.75H20.25C20.6478 20.75 21.0294 20.592 21.3107 20.3107C21.592 20.0294 21.75 19.6478 21.75 19.25V5.75C21.75 5.35218 21.592 4.97064 21.3107 4.68934C21.0294 4.40804 20.6478 4.25 20.25 4.25ZM20.25 5.75V9.5H3.75V5.75H20.25ZM3.75 11H9V19.25H3.75V11ZM20.25 19.25H10.5V11H20.25V19.25Z" fill="#08212D" />
        </svg>
    )
}

